import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { Payment } from '~/views/organisms/payment';

export const PagePayment: FC = observer(() => {
    return <Payment />;
});
